export enum ROUTE_NAMES {
  HOME = '/',
  TRADING = '/trading',
  CHARTS = '/charts',
  REPORTS = '/reports/:tab',
  CALENDAR = '/economic-calendar',
  LOGIN = '/login',
  TWO_FA = '/verification',
  REGISTRATION = '/registration',
  RESET_PASSWORD = '/password-reset/:token',
  RESET_PASSWORD_LINK = '/password-reset-link',
  DOCUMENT_REQUESTS = '/account/document_requests',
  PENDING_VERIFICATION = '/account/pending_verification',
  COMPLETED_REQUESTS = '/account/completed_requests',
  HISTORY = '/history',
  DISCOVER = '/discover',
  DEPOSIT = '/account/deposit/',
  DASHBOARD = '/account/dashboard',
  CHANGE_EMAIL_AUTHENTICATOR = '/change-email-authenticator',
  ALL_ALERTS = '/alerts',
}

export function replaceVarsInPath(sourcePath: string, vars: any[]): string {
  const chunks = sourcePath.split('/')
  const newChunks = []

  for (const pathChunk of chunks) {
    if (RegExp(/:/).test(pathChunk)) {
      newChunks.push(vars.shift())
    } else {
      newChunks.push(pathChunk)
    }
  }

  return newChunks.join('/')
}
